import http from "@/utils/http";


export const BmsApplyApi = {
	countApply() {
		return http.get(`/server/bmsApply/countApply`);
	},
	queryApplyList(query){
		return http.get(`/server/bmsApply/list`, query);
	}
}